import { isAfter, isBefore } from 'date-fns';
import { z } from 'zod';

import { isDefined } from '@hsp/utilities';

import { ClientSchemaOptional } from '@t/api';

import { s } from '@u/strings';

export const DailiesFilterFormSchema = z
  .object({
    client: ClientSchemaOptional.optional(),
    dateEnd: z.date().nullish().optional(),
    dateStart: z.date().nullish().optional(),
  })
  .superRefine(({ dateEnd, dateStart }, context) => {
    if (isDefined(dateStart)) {
      if (isDefined(dateEnd) && isAfter(dateStart, dateEnd)) {
        context.addIssue({
          code: z.ZodIssueCode.custom,
          fatal: true,
          message: s(['Site.Pages.AudienceBuilder.Save.Validation.GiftAmount.StartDate']),
          path: ['dateStart'],
        });

        return z.NEVER;
      }
    }

    if (isDefined(dateEnd)) {
      if (isDefined(dateStart) && isBefore(dateEnd, dateStart)) {
        context.addIssue({
          code: z.ZodIssueCode.custom,
          fatal: true,
          message: s(['Site.Pages.AudienceBuilder.Save.Validation.GiftAmount.EndDate']),
          path: ['dateEnd'],
        });

        return z.NEVER;
      }
    }
  });
export type DailiesFilterForm = z.infer<typeof DailiesFilterFormSchema>;
